/* Adds up/down scroll arrows around the product gallery's thumbnail
   column, and forces the thumbnail column to a fixed pixel height that
   exactly matches the main image viewer.

   Why a fixed pixel height instead of CSS align-items:stretch alone:
   stretch worked fine for a product with a handful of thumbnails, but
   on a product with ~26 images (real bug found on the Northshore
   Megamax page) the thumb list's own content became taller than the
   viewer, and with no definite (non-percentage) height anywhere in the
   chain, overflow-y:auto never actually clipped anything — the column
   just grew to fit all 26 thumbnails instead of scrolling. Measuring
   the viewer's real rendered height in JS and applying it as an exact
   inline pixel height on the thumb column removes that ambiguity
   entirely, regardless of how many thumbnails a product has. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('media-gallery').forEach(function (gallery) {
    const viewer = gallery.querySelector('.media-gallery__viewer');
    const thumbsWrap = gallery.querySelector('.media-gallery__thumbs');
    const list = thumbsWrap ? thumbsWrap.querySelector('.media-thumbs') : null;
    if (!viewer || !thumbsWrap || !list) return;

    if (!thumbsWrap.querySelector('.llm-thumb-nav')) {
      const upBtn = document.createElement('button');
      upBtn.type = 'button';
      upBtn.className = 'llm-thumb-nav llm-thumb-nav--up';
      upBtn.setAttribute('aria-label', 'Scroll thumbnails up');
      upBtn.innerHTML = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 10l4-4 4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      const downBtn = document.createElement('button');
      downBtn.type = 'button';
      downBtn.className = 'llm-thumb-nav llm-thumb-nav--down';
      downBtn.setAttribute('aria-label', 'Scroll thumbnails down');
      downBtn.innerHTML = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      upBtn.addEventListener('click', function () {
        list.scrollBy({ top: -120, behavior: 'smooth' });
      });
      downBtn.addEventListener('click', function () {
        list.scrollBy({ top: 120, behavior: 'smooth' });
      });

      thumbsWrap.insertBefore(upBtn, list);
      thumbsWrap.appendChild(downBtn);
    }

    function syncHeight() {
      const viewerHeight = viewer.getBoundingClientRect().height;
      if (viewerHeight > 0) {
        thumbsWrap.style.height = viewerHeight + 'px';
      }
    }

    syncHeight();
    window.addEventListener('resize', syncHeight);

    if (window.ResizeObserver) {
      new ResizeObserver(syncHeight).observe(viewer);
    }
  });
});
